import { createDataSelectors } from "@app/modules/app.reducers";
import { AuditTrail } from "@ea/shared_types/types";

export const auditTrailDataSelectors = createDataSelectors<AuditTrail>()("auditTrail");
